import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaInformacionPrincipal', {
    template: template,
    controller: NominasNominaInformacionPrincipalComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      status: '<',
      data: '<',
    },
  })

function NominasNominaInformacionPrincipalComponent($moment) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.actualizar = actualizar

  function $onInit() {
    $ctrl.editando = false
    $ctrl.data.periodo = periodo($ctrl.data.fecha_inicial, $ctrl.data.fecha_final)
  }

  function actualizar(data) {
    $ctrl.data.periodo = periodo($ctrl.data.fecha_inicial, $ctrl.data.fecha_final)
    angular.extend($ctrl.data, data)
  }

  function periodo(inicio, final) {
    let i = $moment(inicio).format('YYYY,MMMM,D').split(','),
      f = $moment(final).format('YYYY,MMMM,D').split(','),
      c = [i[0] === f[0], i[1] === f[1], i[2] === f[2]]

    if (c[0] && c[1] && c[2])
      return ' del ' + f[2] + ' de ' + f[1] + ' de ' + f[0]
    else if (c[0] && c[1])
      return ' del ' + i[2] + ' al ' + f[2] + ' de ' + f[1] + ' de ' + f[0]
    else if (c[0])
      return ' del ' + i[2] + ' de ' + i[1] + ' al ' + f[2] + ' de ' + f[1] + ' de ' + f[0]
    else
      return ' del ' + i[2] + ' de ' + i[1] + ' de ' + i[0] + ' al ' + f[2] + ' de ' + f[1] + ' de ' + f[0]
  }

}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/principal/component.js